module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/isolated-new-user/isolated-new-user.component.css
// module id = ./src/app/Screens/isolated-new-user/isolated-new-user.component.css
// module chunks = main